// removed by extract-text-webpack-plugin
module.exports = {"carousel-container":"carousel-container___1sJBH","similar-items":"similar-items___vhLDK","item-ended-similar-items-header":"item-ended-similar-items-header___2yx22","similar-grid":"similar-grid___3ghMy","similar-cards":"similar-cards___2pgbe","last-card":"last-card___3CHdd"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SimilarItems/SimilarItems.scss
// module id = blov
// module chunks = 46